import { put, call, takeEvery } from 'typed-redux-saga';

import DiscountGateway from '~apis/discount';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';
import { DiscountTypeEnum, TransactionActionEnum, TransactionStatusEnum } from '~utils/enums';
import UtilFunctions from '~utils/functions';

export default function* watchGetPendingDiscountListing(api: DiscountGateway): SagaWatcherReturnType {
    yield takeEvery('approval/approvalGetPendingDiscountListingAttempt', handleGetPendingDiscountListing, api);
}

function* handleGetPendingDiscountListing(api: DiscountGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const {
        index,
        filters: {
            discountName,
            discountCode,
            transactionType,
            status,
        },
    } = reduxState.approval.pendingDiscountListing;

    if (!index && index !== 0) {
        yield put(combinedActions.approvalGetPendingDiscountListingFailure(ErrorMessages.GenericRequiredFieldNotFilledIn));
        return;
    }

    const response = yield* call([api, api.getDiscountChangeHistoryListing], {
        authToken,
        index,
        discountName: discountName || undefined,
        discountCode: discountCode || undefined,
        discountType: transactionType ? UtilFunctions.Misc.getEnumValueByKey(TransactionActionEnum, transactionType) : undefined,
        status: status ? UtilFunctions.Misc.getEnumValueByKey(TransactionStatusEnum, status) : undefined,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.approvalGetPendingDiscountListingFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.approvalGetPendingDiscountListingSuccess(response.data));
    }
}
